import { useEffect, useState } from 'react';
import { useCustomerAPI } from '../../../clients/customer-api/customer-api-client';
import { DispatchV2 } from '../DispatchV2';
import { DispatchList } from '../../dispatch/dispatch-list';

export const DispatchSelector = () => {
  const [dispatchV2, setDispatchV2] = useState<boolean | undefined>(undefined);

  const { getConfiguration } = useCustomerAPI();
  useEffect(() => {
    getConfiguration('CONF_DISPATCH_V2').then((config) => {
      setDispatchV2(config?.value === '1');
    });
  }, []);

  if (dispatchV2 === undefined) {
    return <></>;
  }

  return <>{dispatchV2 ? <DispatchV2 /> : <DispatchList />}</>;
};
